import {UploadImage} from 'components/UI/Image';
import {DateTime} from 'components/UI/DateTime';

export default function(props) {
  return (
    <div className='item-comment-header'>
      <div className='avatar'>
        <UploadImage transform="crop" width={48} height={48} type='USER' image={props.user.avatar}/>
      </div>
      <div className='content-justify poster-info'>
        <p className='item-comment-business-name'>{props.user.fullname}</p>
        <p className='item-comment-business-desc'><DateTime dateTime={props.message.createdAt}/></p>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./components/conversations/partials/UserMessageHeading.jsx